import React, { forwardRef, useEffect, useRef, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import FixedNavBar from "@/components/fixedNavBar";
import { SearchBar, Image } from "antd-mobile";
import TableTbody from "@/components/tableTbody";
import { ITableColsAdministrator, ITableColsDaicunRecordVault } from "@/type";
import useRouter from "@/hooks/useRouter";
import CalendarTime from "@/components/calendarTime";
import { useFinanceOrderList } from "@/hooks/useOrderRecords";
import useCustomTranslation from "@/hooks/useTranslation";

const CalendarTimeChildComponent = forwardRef(CalendarTime);
const DaicunRecord: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { params: routerParams } = useRouter();
	const TableTbodyTypes: any = {
		"1": {
			title: t("AdministratorRecord"),
			type: ITableColsAdministrator,
			srcList: [
				"PAY",
				"AGENT_CASH",
				"AGENT_CASH_REFUND",
				"DEPOSIT",
				"ADMIN",
			],
			statusList: [3],
		},
		"2": {
			title: t("RecordsChangesVault"),
			type: ITableColsDaicunRecordVault,
			srcList: [],
			statusList: [2, 3],
		},
	};

	const childRef = useRef<any>(null);
	const [firstPage, setFirstPage] = useState(true);
	const [value, setValue] = useState("");
	const params: any = {
		nickname: value,
		// statusList: TableTbodyTypes[routerParams.type || "1"].statusList,
		itemType: 2,
	};
	if (TableTbodyTypes[routerParams.type || "1"].srcList.length) {
		params["srcList"] = TableTbodyTypes[routerParams.type || "1"].srcList;
	}

	const { data, targetData, hasMore, handleRefresh, handleFetchMore } =
		useFinanceOrderList(params, childRef);

	useEffect(() => {
		if (!firstPage) {
			setFirstPage(false);
			handleRefresh();
		}
	}, [value]);

	return (
		<div className="router-main">
			<FixedNavBar
				title={TableTbodyTypes[routerParams.type || "1"].title}
			/>
			<div className={classes.timeSearchWrap}>
				<div className="search">
					<SearchBar
						value={value}
						onChange={(val: string) => {
							setValue(val);
						}}
						onSearch={handleRefresh}
						placeholder={t("Search")}
						style={{
							fontSize: pxToRem(12),
							fontWeight: "400",
							color: "#FFFFFF",
							"--border-radius": pxToRem(40),
							"--height": pxToRem(36),
							"--background": "#1E212B",
							"--placeholder-color": "#868FA8",
						}}
						icon={
							<Image
								src={require("@/assets/images/icons/search.png")}
								width={22}
								height={22}
							/>
						}
					/>
				</div>
				<CalendarTimeChildComponent
					ref={childRef}
					onSubmit={handleRefresh}
				/>
			</div>
			<div style={{ flex: 1, overflow: "hidden" }}>
				<TableTbody
					ITableCols={TableTbodyTypes[routerParams.type || "1"].type}
					ITableData={data}
					targetData={targetData}
					handleRefresh={handleRefresh}
					handleFetchMore={handleFetchMore}
					hasMore={hasMore}
				/>
			</div>
		</div>
	);
};

export default DaicunRecord;

const useStyles = createUseStyles({
	timeSearchWrap: {
		padding: {
			top: pxToRem(15),
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"& .search": {
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(40),
			"--adm-color-background": "#1E212B",
			"& .adm-input-element": {
				"--color": "#FFFFFF",
			},
		},
	},
});
